import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import DailyLeadLogItem from './DailyLeadLogItem';
import DateDesignerLeadFilter from './DateDesignerLeadFilter';
import ListView from '../shared/lists/ListView';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import ExportButton from '../shared/buttons/ExportButton'

const DailyLeadLog = ({
    items,
    filter,
    pageInfo,
    setFilter,
    setUrl
}) => {
    const postUrl = `/api/reports/dailyleadlog`;

    useEffect(() => setUrl(postUrl), []);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Created"
                    sort={pageInfo}
                    sortName="DateCreated"
                />
                <SortableTh
                    content="Appt."
                    sort={pageInfo}
                    sortName="StartTime"
                />
                <SortableTh
                    content="First"
                    sort={pageInfo}
                    sortName="FirstName"
                />
                <SortableTh
                    content="Last"
                    sort={pageInfo}
                    sortName="LastName"
                />
                <SortableTh
                    content="Address"
                    sort={pageInfo}
                    sortName="Address"
                />
                <SortableTh
                    content="Phone"
                    sort={pageInfo}
                    sortName="Phone"
                />
                <SortableTh
                    content="Email"
                    sort={pageInfo}
                    sortName="Email"
                />
                <SortableTh
                    content="Areas"
                    sort={pageInfo}
                    sortName="AreaCount"
                />
                <SortableTh
                    content="Lead Source"
                    sort={pageInfo}
                    sortName="LeadSource"
                />
                <SortableTh
                    content="Sub Source"
                    sort={pageInfo}
                    sortName="SubLeadSource"
                />
                <SortableTh
                    content="Designer"
                    sort={pageInfo}
                    sortName="Designer"
                />
                <th>Created By</th>
                <SortableTh
                    content="Note"
                    sort={pageInfo}
                    sortName="Note"
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/dailyLeadLog"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items.map((item, index) =>
        <DailyLeadLogItem
            item={item}
            key={item.id}
        />
    );

    return (
        <Row>
            <Col>
                <DateDesignerLeadFilter
                    filter={filter}
                    setFilter={setFilter}
                    hideDesignerFilter={true}
                />
                <Row className='pb-5 mt-3'>
                    <Col className="small">
                        <ListView
                            animate={false}
                            canAdd={false}
                            items={listItems}
                            tableHead={tableHead}
                        />
                        <PagedListControl
                            {...pageInfo}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default React.memo(DailyLeadLog);